import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import Button from '../../../common/Button'
import InputText from '../../../common/InputText'
import { postRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'
import SelectInput from '../../../common/SelectInput'
import { CAN_CHANGE_ROLE } from '../../../../constants/permission'

const UserEditCreateForm = (props) => {
  const [state, dispatch] = useContext(NavContext)

  const [userDetails, setUserDetails] = useState({
    email: '',
    password: '',
    last_name: '',
    first_name: '',
    is_active: true,
    role: [],
  })

  useEffect(() => {
    if (props?.userDetails?.email) {
      setUserDetails(props?.userDetails)
    }
  }, [props?.userDetails])

  const saveUserDetails = async (e) => {
    const form = e.target
    const formData = new FormData(form)

    let res = await postRequest(`/api/users/save_user/`, formData)
    if (Object.keys(res?.errors).length > 0) {
      let msg = ''
      Object.keys(res?.errors).map((obj) => {
        if (msg) {
          msg += `, ${res.errors[obj]}`
        } else {
          msg = `${res.errors[obj]}`
        }
      })

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    } else if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      props.onSave()
    }
  }

  const showHidePassword = () => {
    let x = document.getElementById('password')
    if (x.type === 'password') {
      x.type = 'text'
    } else {
      x.type = 'password'
    }
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveUserDetails(e)
        }}
      >
        <input type="hidden" value={!props.isEdit} name="is_create" />
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="first_name"
              type="text"
              label="First Name"
              value={userDetails.first_name}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="last_name"
              type="text"
              label="Last Name"
              value={userDetails.last_name}
              onChange={(value) => {
                setUserDetails({ ...userDetails, last_name: value })
              }}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="email"
              type="email"
              label="Email"
              value={userDetails.email}
              onChange={(value) => {
                setUserDetails({ ...userDetails, email: value })
              }}
            />
          </div>
          {!props?.isEdit && (
            <div className="flex w-1/2 items-end">
              <InputText
                name="password"
                type="password"
                label="Password"
                value={userDetails.password}
                onChange={(value) => {
                  setUserDetails({ ...userDetails, password: value })
                }}
              />
              <span
                className="p-2 underline cursor-pointer"
                onClick={() => {
                  showHidePassword()
                }}
              >
                show
              </span>
            </div>
          )}
          <div
            className={`flex w-1/2 items-end ${!state?.permissions?.includes(CAN_CHANGE_ROLE) ? 'disabled' : ''}`}
          >
            <SelectInput
              value={props?.roleList?.filter((role) =>
                userDetails.role.includes(role?.id)
              )}
              onChange={(value) => {
                setUserDetails({
                  ...userDetails,
                  role: value.map((obj) => obj.id),
                })
              }}
              label="Select Role"
              name="role"
              isRequired={true}
              isMulti={true}
              options={props?.roleList}
              optionLabel={'name'}
              optionValue={'id'}
            />
          </div>

          <input
            type="hidden"
            value={userDetails?.is_active}
            name="is_active"
          />
        </div>

        <div className="flex justify-end">
          <div className="w-1/4">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={props.isEdit ? 'Save User' : 'Create New User'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

UserEditCreateForm.propTypes = {
  userDetails: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
}

export default UserEditCreateForm
